<template>
    <v-row align="center"
           justify="center">
                    <h1 word-wrap>Herzlich Willkommen - Im Moment befindet sich meine Webseite noch im Aufbau</h1>
    </v-row>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style>
    .page--home{
        background-color: #263238;
        background-image: url('~@/assets/bg/home.png');
        background-position: center center;
        -ms-background-size: cover;
        -o-background-size: cover;
        -moz-background-size: cover;
        -webkit-background-size: cover;
        background-size: cover;
    }
</style>
